import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import {
	GroupContainer,
	GroupHeading,
	GroupHeadingTextContainer,
	IconContainer,
	AllAction,
	InfoBadgeContainer,
} from './dropdown.styled';
import {CaretIcon} from '../../icons/caret-icon';
import {Item} from './Item';

export const Group = ({
	name,
	infoText,
	children,
	onElementClick,
	onRemoveClick,
	startIndex,
	focusIndex,
	onNavigation,
	onClick,
	actionType,
	onSelectAllClick,
	onRemoveAllClick,
	onFocus,
	cy,
	initiallyCollapsed,
	isSearching,
	hideCount,
}) => {
	const [expanded, setExpanded] = useState(!initiallyCollapsed);
	const refs = useRef({});

	useEffect(() => {
		if (initiallyCollapsed) {
			setExpanded(isSearching);
		}
	}, [initiallyCollapsed, isSearching]);

	const shouldFocus = index => {
		if (index === focusIndex) {
			if (refs.current[index]) onFocus(refs.current[index]);
			return true;
		}
	};

	const setRef = (ref, index) => {
		refs.current[index] = ref;
	};

	const childrenList = React.Children.map(children, child => {
		let index = startIndex++;
		return (
			<Item
				onSetInnerRef={ref => setRef(ref, index)}
				onKeyDown={onNavigation}
				showFocus={shouldFocus(index)}
				noPadding={child.props.noPadding}
				onClick={child.props.disabled ? () => null : onElementClick}
				cy={child.props.cy}
				key={child.props.value}
				value={child.props.value}
				onRemoveClick={onRemoveClick}
			>
				{child}
			</Item>
		);
	});

	const handleGroupClick = () => {
		setExpanded(!expanded);
	};
	return (
		<GroupContainer data-cy={cy}>
			<GroupHeading
				onClick={() => {
					handleGroupClick();
					onClick();
				}}
			>
				<GroupHeadingTextContainer>
					<p>
						<b>{name}</b> {!hideCount && <span>({childrenList.length})</span>}
					</p>
				</GroupHeadingTextContainer>
				<AllAction>
					{actionType === 'clear' ? <p onClick={onRemoveAllClick}>Clear All</p> : null}
					{actionType === 'select' ? <p onClick={onSelectAllClick}>Select All</p> : null}
				</AllAction>
				{infoText && <InfoBadgeContainer>{infoText}</InfoBadgeContainer>}
				<IconContainer>
					<CaretIcon direction={expanded ? CaretIcon.DIRECTION.UP : CaretIcon.DIRECTION.DOWN} />
				</IconContainer>
			</GroupHeading>
			{expanded && childrenList}
		</GroupContainer>
	);
};

Group.propTypes = {
	onSelectAllClick: PropTypes.func,
	onRemoveAllClick: PropTypes.func,
	actionType: PropTypes.oneOf(['clear', 'select']),
	onClick: PropTypes.func,
	onNavigation: PropTypes.func,
	startIndex: PropTypes.number,
	focusIndex: PropTypes.number,
	name: PropTypes.string.isRequired,
	infoText: PropTypes.string,
	children: PropTypes.any,
	onElementClick: PropTypes.func,
	onRemoveClick: PropTypes.func,
	onFocus: PropTypes.func,
	cy: PropTypes.string,
	initiallyCollapsed: PropTypes.bool,
	hideCount: PropTypes.bool,
	isSearching: PropTypes.bool,
};
